(function (window) {
    const TRUTHY_ENV_VALUES = ['true', 'TRUE', 't', 'T', '1', 'enabled', 'ENABLED'];
    const FALSY_ENV_VALUES = ['false', 'FALSE', 'f', 'F', '0', 'disabled', 'DISABLED'];
    const snapshot = '${USER_ENV_SNAPSHOT_FOR_NG_APP_ENV_VARS}';
    if (!/^\$\{(.+?)\}$/.test(snapshot) && /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/.test(snapshot)) {
        // Decoding to UTF-8 using ASCII base64 interoperability https://stackoverflow.com/a/30106551
        const parseObj = JSON.parse(decodeURIComponent(atob(snapshot).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join('')));
        if (parseObj !== null && typeof parseObj === 'object' && !Array.isArray(parseObj)) {
            window.injectedUserEnv = {};
            Object.entries(parseObj).forEach(([key, value]) => {
                if (typeof value === 'string') {
                    if (!isNaN(Number(value))) {
                        window.injectedUserEnv[key] = Number(value);
                    } else if (TRUTHY_ENV_VALUES.includes(value)) {
                        window.injectedUserEnv[key] = true;
                    } else if (FALSY_ENV_VALUES.includes(value)) {
                        window.injectedUserEnv[key] = false;
                    } else {
                        window.injectedUserEnv[key] = value;
                    }
                } else {
                    window.injectedUserEnv[key] = String(value);
                }
            });
        } else {
            window.injectedUserEnv = undefined;
            console.warn('Encountered an invalid JSON format when parsing snapshot');
        }
    } else {
        window.injectedUserEnv = undefined;
        console.warn('Encountered an invalid snapshot (either a template or not base64 encoded)');
    }
})(this);
